import { validateIban } from '@insify/ui-utils';
import * as yup from 'yup';

import type { TFunction } from 'i18next';

export const validation = (t: TFunction<['common', 'validation', 'funnel']>) =>
  yup.object().shape({
    startDate: yup.string().required(t('validation:checkout_start_date_required')),
    paymentMethod: yup.string().required(t('validation:checkout_payment_method_required')),
    iban: yup.string().when('paymentMethod', {
      is: 'sepa',
      then: (schema) =>
        schema
          .required(t('validation:checkout_iban_required'))
          .test('IBAN validation', t('validation:checkout_iban_invalid'), validateIban),
    }),
  });
